// components/common/CountryFlag.jsx
import React from 'react';

/**
 * CountryFlag component that displays flag images instead of emoji
 * Uses flagcdn.com for reliable flag images that work across all platforms
 */
const CountryFlag = ({ 
  countryCode, 
  size = 'w-5 h-4', 
  alt, 
  className = '',
  rounded = 'rounded-sm',
  fallbackEmoji = true 
}) => {
  if (!countryCode) {
    return null;
  }

  const code = countryCode.toLowerCase();
  const flagUrl = `https://flagcdn.com/24x18/${code}.png`;
  const altText = alt || `${countryCode} flag`;

  const handleError = (e) => {
    if (fallbackEmoji) {
      // Convert country code to flag emoji as fallback
      const codePoints = countryCode
        .toUpperCase()
        .split('')
        .map(char => 127397 + char.charCodeAt());
      const flagEmoji = String.fromCodePoint(...codePoints);
      
      // Replace image with emoji fallback
      e.target.outerHTML = `<span class="inline-flex items-center justify-center ${size} text-xs">${flagEmoji}</span>`;
    } else {
      e.target.style.display = 'none';
    }
  };

  return (
    <img
      src={flagUrl}
      alt={altText}
      className={`${size} ${rounded} object-cover inline-block ${className}`}
      onError={handleError}
      loading="lazy"
    />
  );
};

export default CountryFlag;